module.exports = __webpack_public_path__ + "static/media/contratoprimario2027.789b7c77.pdf";